import { useQuery } from "@tanstack/react-query";
import { fetchUserArtists } from "utils";
import { Artist } from "types";
import { useAuthentication } from "context/AuthenticationContext";

export const getArtistsQueryKey = (userId: string) => ["artists", userId];

export const useArtists = () => {
    const auth = useAuthentication();

    const { data: artists = [], refetch: getArtists } = useQuery<Artist[]>({
        queryKey: getArtistsQueryKey(auth.user?.id || ""),
        queryFn: async () => {
            const data = await fetchUserArtists();
            return data ? data.data : [];
        },
        enabled: auth.isAuthenticated && !!auth.user,
    });

    return { artists, getArtists };
};
